module.exports = __webpack_public_path__ + "static/media/font_bold.475c1aa1.woff2";